import Light, { LightArgs } from "./Light";

export type PointLightArgs = {
} & LightArgs;

export class PointLight extends Light {
  constructor(args: PointLightArgs) {
    super(args);
  }
}
